import type { PlatformSettingHistory } from '../../types';

export const HISTORY_PAGE_SIZE = 20;
export const HISTORY_SCROLL_THRESHOLD_PX = 80;

export function getNextHistoryPageParam(lastPage: {
  page: number;
  limit: number;
  total: number;
}): number | undefined {
  return lastPage.page * lastPage.limit < lastPage.total
    ? lastPage.page + 1
    : undefined;
}

export function shouldLoadMoreHistory(args: {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  thresholdPx?: number;
}): boolean {
  if (!args.hasNextPage || args.isFetchingNextPage) {
    return false;
  }
  const remaining = args.scrollHeight - args.scrollTop - args.clientHeight;
  return remaining <= (args.thresholdPx ?? HISTORY_SCROLL_THRESHOLD_PX);
}

export function flattenHistoryPages(
  pages: readonly PlatformSettingHistory[] | undefined,
): {
  items: PlatformSettingHistory['data'];
  total: number;
} {
  if (!pages || pages.length === 0) {
    return { items: [], total: 0 };
  }
  return {
    items: pages.flatMap((page) => page.data),
    total: pages[0]?.total ?? 0,
  };
}
